import React from "react";
import { View } from "components/utils/View";

export const FlightEvent = () => {
  return <View width={40} height={0} view="FLIGHT_EVENT" />;
};
